import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as mesasService from '../../services/mesas/mesasService';
import {
  classifyMesasError,
  toCreateMesaPayload,
  validateMesaDatesInPeriodo,
  validateMesaDatesOK,
  validateMesaForm
} from '../../services/mesas/mesasDto';
import { LookupPeriodoExamen } from '../PeriodoExamen/LookupPeriodoExamen';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import { parseDate, todayCalendarDate } from '../../services/dates/dateService';
import { CalendarDatePicker } from '../common/CalendarDatePicker';

export class AddMesaExamen extends Component {
  static displayName = AddMesaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      periodo: { codigo: 0, descripcion: '', fechaInicioPeriodo: todayCalendarDate(), fechaFinPeriodo: todayCalendarDate() },
      materia: { materiaCodigo: '', materiaNombre: '' },
      showLookupMaterias: false,
      showLookupPeriodoCursada: false,
      fechaExamen: todayCalendarDate(),
      fechaInicioInscripcion: todayCalendarDate(),
      fechaFinInscripcion: todayCalendarDate(),
    };
  }

  handleConfirmButton = () => {
    const okToSave = validateMesaForm({
      materiaPresent: this.state.materia.materiaCodigo.length > 0,
      periodoPresent: this.state.periodo.descripcion.length > 0
    });
    const fechasOk = validateMesaDatesOK(
      this.state.fechaInicioInscripcion,
      this.state.fechaFinInscripcion,
      this.state.fechaExamen
    );
    const fechasEnPeriodo = validateMesaDatesInPeriodo({
      periodoInicio: this.state.periodo.fechaInicioPeriodo,
      periodoFin: this.state.periodo.fechaFinPeriodo,
      fechaExamen: this.state.fechaExamen,
      fechaInicioInscripcion: this.state.fechaInicioInscripcion,
      fechaFinInscripcion: this.state.fechaFinInscripcion,
    });

    if (okToSave && fechasOk && fechasEnPeriodo) {
      this.saveStudent();
      return;
    }

    let errorMessage = '';
    if (!okToSave) {
      errorMessage = 'Todos los campos son obligatorios';
    } else if (!fechasOk) {
      errorMessage = 'Compruebe las fechas ingresadas, las fechas de inscripción deben ser menor a la fecha del examen';
    } else {
      errorMessage = 'Compruebe que las fechas se encuentren dentro del período de examen seleccionado';
    }
    this.setState({ showErrorMessage: true, errorMessage });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupMaterias: false,
      showErrorMessage: false,
      errorMessage: '',
      materia: {
        materiaCodigo: carreraProperties[0],
        materiaNombre: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[3].trim()
      }
    });
  };

  handleSelectPeriodoCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupPeriodoCursada: false,
      showErrorMessage: false,
      errorMessage: '',
      periodo: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[3].trim(),
        fechaInicioPeriodo: parseDate(carreraProperties[4]),
        fechaFinPeriodo: parseDate(carreraProperties[5])
      }
    });
  };

  async componentDidMount() {
    await constantClass.canAccess('WWMesaExamen');
  }

  handleFechaExamen = (date) => {
    this.setState({ fechaExamen: date, showErrorMessage: false, errorMessage: '' });
  };

  handleFechaInicioInscripcion = (date) => {
    this.setState({ fechaInicioInscripcion: date, showErrorMessage: false, errorMessage: '' });
  };

  handleFechaFinInscripcion = (date) => {
    this.setState({ fechaFinInscripcion: date, showErrorMessage: false, errorMessage: '' });
  };

  handleHideLookup = () => {
    this.setState({ showLookupMaterias: false });
  };

  handleHidePeriodoCursadaLookup = () => {
    this.setState({ showLookupPeriodoCursada: false });
  };

  handleShowCarreraLookup = () => {
    this.setState({ showLookupMaterias: true });
  };

  handleShowPeriodoCursadaLookup = () => {
    this.setState({ showLookupPeriodoCursada: true });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-mex" />;
    }

    const { loading } = this.state;
    const materiaDisplay = this.state.materia.materiaNombre.trim();
    const periodoDisplay = this.state.periodo.descripcion.trim();

    return (
      <div className="md-page md-add-mex">
        <Link className="md-page__back-link" to="/md-mex">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nueva Mesa de Examen</h1>
        </div>
        <p className="md-page__subtitle">
          Seleccione la materia y el período de examen, luego defina las fechas de inscripción y del examen.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Materia</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCarreraLookup}>
                  Seleccionar materia
                </button>
              ) : null}
              <div className="md-page__field-readonly">{materiaDisplay || '\u00a0'}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Período de examen</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowPeriodoCursadaLookup}>
                  Seleccionar período de examen
                </button>
              ) : null}
              <div className="md-page__field-readonly">{periodoDisplay || '\u00a0'}</div>
            </div>
          </div>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Fechas</p>
            <div className="md-page__field">
              <label className="md-page__field-label" htmlFor="mex-fecha-examen">
                Fecha de examen
              </label>
              <CalendarDatePicker
                inputId="mex-fecha-examen"
                className="md-page__field-input"
                selected={this.state.fechaExamen}
                onChange={this.handleFechaExamen}
                disabled={loading}
              />
            </div>

            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="mex-inicio-inscripcion">
                  Inicio de inscripción
                </label>
                <CalendarDatePicker
                  inputId="mex-inicio-inscripcion"
                  className="md-page__field-input"
                  selected={this.state.fechaInicioInscripcion}
                  onChange={this.handleFechaInicioInscripcion}
                  disabled={loading}
                />
              </div>

              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="mex-fin-inscripcion">
                  Fin de inscripción
                </label>
                <CalendarDatePicker
                  inputId="mex-fin-inscripcion"
                  className="md-page__field-input"
                  selected={this.state.fechaFinInscripcion}
                  onChange={this.handleFechaFinInscripcion}
                  disabled={loading}
                />
              </div>
            </div>
          </section>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Confirmar
            </button>
          </div>
        </div>

        {this.state.showLookupMaterias ? (
          <LookupMaterias selectItem={this.handleSelectCarreraItem} hideLookup={this.handleHideLookup} />
        ) : null}
        {this.state.showLookupPeriodoCursada ? (
          <LookupPeriodoExamen selectItem={this.handleSelectPeriodoCursadaItem} hideLookup={this.handleHidePeriodoCursadaLookup} />
        ) : null}
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await mesasService.saveMesa(
        toCreateMesaPayload({
          fechaExamen: this.state.fechaExamen,
          fechaInicioInscripcion: this.state.fechaInicioInscripcion,
          fechaFinInscripcion: this.state.fechaFinInscripcion,
          periodoExamenCod: this.state.periodo.codigo,
          materiaCarreraCod: this.state.materia.materiaCodigo
        })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyMesasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({ loading: false, success: false, showErrorMessage: true, errorMessage: outcome.message });
    }
  }
}
